<template>
  <div class="row">
    <div class="left-column"></div>
    <div class="right-column">
      <Loading v-if="loggingIn" text="Loading..." />
      <div class="main-input-form-container" v-if="!loggingIn">
        <div class="gemnote-logo">
          <a href="https://www.gemnote.com/" target="_blank" rel="noreferrer">
            <img src="../assets/gemnote_logo_pebble.png" />
          </a>
        </div>
        <form @submit.prevent>
          <h3 class="title">
            <span> {{ $t('Welcome!') }} </span> <br />
            {{ $t("We're so glad you are here.") }}
          </h3>

          <section class="form-holder">
            <div class="form-group">
              <input
                type="text"
                :placeholder="$t('login.ui.team-name-placeholder')"
                class="form-control"
                v-model="teamName"
              />
            </div>
          </section>
          <div class="login-button">
            <button
              class="button-gemnote button-gemnote--small"
              @click="handleFormSubmit"
              v-if="!loggingIn"
              :disabled="loggingIn"
            >
              <span>{{ $t('login.ui.btn-login') }}</span>
            </button>
          </div>

          <!-- Sign In Option Region -->
          <div class="option-region">
            <p><span>or </span></p>

            <!-- Google button here -->
            <div class="sso-sign-in">
              <button
                class="google-btn whitebutton-gemnote full-btn whitebutton-gemnote--small w-full"
                :disabled="loggingIn"
                @click="handleGoogleLogin"
              >
                <img src="../assets/google.svg" alt="google" />
                <span>Sign in with Google</span>
              </button>
              <!-- Email button here -->
              <div class="">
                <EmailSignIn @onEmailSignIn="$router.push({ name: 'login' })" />
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="footer-links">
        <FooterLinks />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { layouts } from '../helpers'
import FooterLinks from '@/components/Universal/FooterLinks'
import EmailSignIn from '../components/AuthButtons/EmailSignIn.vue'

export default {
  name: 'SSOLogin',
  components: { FooterLinks, EmailSignIn },
  data() {
    return {
      teamName: ''
    }
  },

  computed: mapState({
    loggingIn: state => state.auth.loggingIn
  }),

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.DEFAULT_LAYOUT)
  },

  methods: {
    handleFormSubmit() {
      if (!this.teamName) {
        this.$store.dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: ['Team name is required']
          },
          { root: true }
        )
      } else {
        this.handleOktaSignIn()
      }
    },
    handleOktaSignIn() {
      this.$store.dispatch('auth/oktaSignIn', { teamName: this.teamName })
    },

    handleGoogleLogin() {
      this.$store.dispatch('auth/fetchGoogleLoginUrl', {})
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.form-group {
  margin-bottom: 1.75rem;

  &.relative {
    margin-bottom: 0;
  }
}

.row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(45%, 1fr));
  grid-template-rows: auto;
  height: 100vh;
}

.right-column {
  background: $main-white;
  flex-direction: column;
  display: flex;
  justify-content: space-between;

  .footer-links {
    padding: 0 8rem 2rem 8rem;
  }
}

.left-column {
  background: url('../assets/Gemnote_SignOn_1.png');
  background-size: cover;
  background-position: center;
}

.gemnote-logo {
  text-align: left;

  a {
    &:hover {
      opacity: 1;
    }
  }

  img {
    width: auto;
    height: 4.25rem;
  }
}

.main-input-form-container {
  padding: 8rem;
}

form {
  margin-top: 2.5rem;

  h3 {
    font-size: 3.938rem;
    line-height: 4.5rem;
    font-weight: normal;
    text-align: left;
    padding-bottom: 1rem;
  }

  h5 {
    text-align: left;
    padding-bottom: 1rem;
  }

  .form-holder {
    margin-top: 1.5rem;
    width: 55%;

    input {
      font-size: 1rem !important;
      font-family: $inter;

      &.isError {
        border-color: #ce3c3c;
      }

      &::placeholder {
        font-weight: 400 !important;
        color: #232220;
        opacity: 0.4;
      }
    }
  }

  .login-button {
    margin-top: 2rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    gap: 1rem;

    button {
      height: 2.5rem;
      font-size: 0.875rem;
      padding: 0 1.5rem;
      font-weight: normal;
    }
  }

  p {
    text-align: left;
  }
}

.login-options {
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;

  .link {
    font-family: $inter;
    font-size: 0.875rem;
    color: $main-6;
    text-decoration: underline;
  }
}

.icon {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 14px;
  transition: transform 0.8s;

  &.rotate {
    transform: rotateX(180deg);
  }
}

.option-region {
  text-align: left;
  margin-top: 2.75rem;

  p {
    width: 24%;
    text-align: center;
    border-bottom: 1px solid #a09c95;
    color: #a09c95;
    font-size: 1rem;
    font-weight: normal;
    line-height: 0.1em;
    margin: 10px 0 20px;

    span {
      background: #f5f2ee;
      padding: 0 10px;
    }
  }

  .sso-sign-in {
    margin-top: 2.75rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    gap: 1rem;
    width: 100%;
  }

  .google-btn {
    height: 40px;
    padding: 0 12px;
    background: transparent;
    display: flex;
    align-items: center;
    font-family: 'Inter', sans-serif;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    span {
      margin-left: 0.5rem;
      font-weight: inherit;
      text-transform: none !important;
    }
  }
}

@media screen and (max-width: 1500px) and (min-width: 900px) {
  .main-input-form-container {
    padding: 6rem;
  }

  .footer-links {
    padding: 6rem !important;
  }
}

@media (max-width: 1100px) {
  .row {
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    transition: 1s ease-in;
  }

  .left-column {
    height: 50vh;
  }

  .right-column {
    height: 50vh;
  }

  .gemnote-logo {
    padding-bottom: 1rem;
  }

  .main-input-form-container {
    padding: 2rem;
  }

  .footer-links {
    padding: 2rem !important;
  }

  form {
    margin: 0 auto;

    .login-button {
      padding-top: 1rem;
      width: 100%;
    }

    p {
      margin: 0rem 0rem;
    }
  }
  .sso-sign-in {
    width: 100%;
  }
}

@media (max-width: 575.98px) {
  .main-input-form-container {
    padding: 1rem;
  }
  .form-holder {
    width: 100% !important;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .form-holder {
    width: 100% !important;
  }
  .sso-sign-in {
    width: 70%;
  }
}
@media (min-width: 576px) {
  .option-region {
    .sso-sign-in {
      width: 50%;
    }
  }
  form {
    .login-button {
      width: 50%;
    }
  }
}
@media (min-width: 1200px) {
  .option-region {
    .sso-sign-in {
      width: 80%;
    }
  }
  form {
    .login-button {
      width: 25%;
    }
  }
}
</style>
